import { usePipelineTagsTableContext } from 'app/settings/tags-page/context/PipelineTagsTableContext';

export default function useValidateUniqueLabel({ excludeLabel } = {}) {
  const { tags } = usePipelineTagsTableContext();
  const existingLabels = buildExistingLabels(tags, excludeLabel);

  return function validateUniqueLabel(value) {
    if (existingLabels.has(value.toLowerCase())) {
      return 'A tag with this label already exists';
    }

    return true;
  };
}

function buildExistingLabels(tags, excludeLabel) {
  const labels = tags.map(tag => tag.label.toLowerCase());
  const filtered = excludeLabel ? labels.filter(label => label !== excludeLabel.toLowerCase()) : labels;
  return new Set(filtered);
}
